export default __webpack_public_path__ + "static/media/rounded_logo.b9f49dfb.svg";